/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_ShareInputs */



/**
* | output |
* | --- |
* | "Share profile" |
*
* @param {Profile_ShareInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_share = /** @type {((inputs?: Profile_ShareInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_ShareInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Partager le profil")
	if (locale === "es") return /** @type {LocalizedString} */ ("Compartir perfil")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Compartilhar perfil")
	if (locale === "it") return /** @type {LocalizedString} */ ("Condividi profilo")
	return /** @type {LocalizedString} */ ("Share profile")
});